<template>
  <section id="download-pro-app">
    <div
      v-if="mounted"
      class="dpa-card-container"
    >
      <div class="dps-top-container">
        <div class="dps-header-container">
          <img
            src="@shared/assets/img/general/pro-app-logo.svg"
            alt="pro-app-logo"
            class="pro-app-logo"
          >
          <div class="dps-header">
            SmartAC.com PRO App access
          </div>
        </div>
        <div class="dps-body">
          <ul>
            <li>
              <b>PRO app</b> for full field management of customer, system, leads, etc
            </li>
            <li>
              Proactive outreach to drive revenue not respond to it
            </li>
            <li>
              The #1 platform for contractors to access
              revenue opportunities <b>across all HVAC brands</b>
            </li>
          </ul>
        </div>
      </div>
      <ProAppBody />
    </div>
  </section>
</template>

<script>
import ProAppBody from '@shared/components/proApp/ProAppBody.vue';

export default {
  name: 'DownloadProAppView',
  metaInfo: {
    title: 'SmartAC.com | Download Pro App',
  },
  components: {
    ProAppBody,
  },
  data() {
    return {
      mounted: false,
    };
  },
  mounted() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      window.location = 'https://play.google.com/store/apps/details?id=com.smartac.pro.app.com';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location = 'https://apps.apple.com/us/app/smartac-com-pro/id1536845908';
    }
    setTimeout(() => { this.mounted = true; }, 1000);
  },
};
</script>

<style lang="scss">

section#download-pro-app {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 36px 0;
  background-color: $WHITE;
  min-height: 100vh;

  .dpa-card-container {
    background-color: $WHITE;
    border-radius: 10px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    max-width: 840px;
    width: 100%;
    margin: 0 16px;

    .dps-top-container {
      display: flex;
      flex-direction: column;
      padding: 28px;

      .dps-header-container {
        display: flex;
        align-items: center;
        margin-bottom: 36px;

        .dps-header {
          font-size: 1.5rem;
          font-weight: 600;
          margin-left: 45px;
        }
      }

      .dps-body {
        font-weight: 500;
      }
    }
  }
}

@media (max-width: 600px) {
  section#download-pro-app {
    padding: 16px 0;

    .dpa-card-container {
      margin: 0 8px;
      border-radius: 8px;

      .dps-top-container {
        padding: 20px 16px;

        .dps-header-container {
          flex-direction: column;
          text-align: center;
          margin-bottom: 20px;

          .pro-app-logo {
            margin-bottom: 12px;
          }

          .dps-header {
            margin-left: 0;
            font-size: 1.25rem;
          }
        }

        .dps-body {
          ul {
            padding-left: 20px;

            li {
              margin-bottom: 8px;
              font-size: 0.9rem;
            }
          }
        }
      }
    }
  }
}
</style>
